module.exports = __webpack_public_path__ + "img/testimonial.709fb5f1.png";